export default "__VITE_ASSET__7f60e04e__"